module.exports = __webpack_public_path__ + "static/media/30-5.a7d0e508.mp3";